module.exports = __webpack_public_path__ + "files/resume.88887e05.pdf";